'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAward } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import Tooltip from '@/app/_components/Tooltip';
const capitalize = str => str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
const BestSellerBadge = t0 => {
  const $ = _c(5);
  const {
    isBestSeller,
    productName
  } = t0;
  if (!isBestSeller) {
    return null;
  }
  let t1;
  if ($[0] !== productName) {
    t1 = capitalize(productName);
    $[0] = productName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `The ${t1} is a best seller`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="cursor-pointer text-light hover:text-primary transition-colors duration-200"><FontAwesomeIcon icon={faAward} className="text-3xl" /></span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <Tooltip content={t2} side="bottom">{t3}</Tooltip>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default BestSellerBadge;